angular.module('zc.projects')

.directive 'campaignIncentiveStep', ($state) ->

  restrict: 'E'
  scope:
    project: '='
    campaign: '='
    incentives: '='
    incentiveForm: '='
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_incentive_step.html'
  link: (scope, element, attrs) ->
    scope.isValid = false
    scope.filteredIncentives = []

    scope.incentiveRegistrationUrl = $state.href('admin.projects.incentives', { projectId: scope.campaign.project_id })

    scope.checkFormValidity = ->
      scope.isValid = !scope.campaign.requires_incentives or
        scope.campaign.incentive_ids.length > 0

    scope.filterIncentives = ->
      scope.filteredIncentives = _.reject(scope.incentives, (incentive) ->
        _.find(scope.campaign.incentives, { id: incentive.id }))

      angular.forEach scope.filteredIncentives, (incentive) ->
        if incentive.incentive_type == 'api_url'
          incentive.example = " [#{incentive.api_url}]"
        else if incentive.incentive_type == 'coupon_url'
          incentive.example = " [#{incentive.pc_base_url}]"
        else if incentive.incentive_type == 'botbonnie_short_url'
          incentive.example = " [#{incentive.botbonnie_short_url}]"
        else
          incentive.example = " [#{incentive.coupon_code}]"

      scope.checkFormValidity()

    scope.add = (incentive) ->
      scope.campaign.incentives = _.sortBy scope.campaign.incentives.concat(incentive), (d) -> new Date('start_at')
      scope.campaign.incentive_ids = _.map scope.campaign.incentives, 'id'
      scope.filterIncentives()

    scope.$watch 'campaign.requires_incentives', (requiresIncentives, previousValue) ->
      return if previousValue is requiresIncentives
      if previousValue and scope.campaign.is_infinite
        scope.campaign.is_infinite = false
      scope.checkFormValidity()

    scope.$watch 'campaign.incentives', (currentIncentiveList, previousIncentiveList) ->
      isIncentiveRemoved = currentIncentiveList.length < previousIncentiveList.length
      scope.filterIncentives() if isIncentiveRemoved

    scope.$watch 'isValid', (isValid) ->
      scope.incentiveForm.$setValidity 'campaign.incentives', isValid

    scope.filterIncentives()



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/directives/campaign_incentive_step.coffee